import { ChangeDetectorRef, Directive, inject, signal } from "@angular/core";
import { ModalData } from "./modal.service";

@Directive()
export class ModalComponent<T = {}> {
    readonly params = signal<ModalComponent.Data<T> | undefined>(undefined);

    /**
     * @deprecated use `params()` instead
     */
    get data(): ModalComponent.Data<T> {
        return this.params()!;
    }

    /**
     * @deprecated use `params.set`/`params.update` instead
     */
    set data(value: ModalComponent.Data<T>) {
        this.params.set(value);
    }

    readonly cd = inject(ChangeDetectorRef);
}

export namespace ModalComponent {
    export type Data<T> = T & ModalData;
    export type Params<T extends ModalComponent<any>> = T extends ModalComponent<infer U> ? U : never;
}
